import { INDIVIDUAL_OPTIONS } from "../_constants/individualOptionsFields.constant";

const setIndividualFields = (fields) => {
    return {
        type: INDIVIDUAL_OPTIONS.SET_FIELDS,
        data: { fields },
    }
};

const clearIndividualFields = () => {
    return {
        type: INDIVIDUAL_OPTIONS.CLEAR_FIELDS,
    }
};

export const individualFieldsActions = {
  setIndividualFields,
  clearIndividualFields
};
